import { GetSchemaStateDownloadResponse } from '../types/api-response';
import { Position } from '../types/erd';
import { apiService } from './api';

interface ResolvedSchemaStateResponse {
  positions: Record<string, Position>;
  sourceVersionId: string | null;
}

export class ErdSchemaStateService {

  public async getResolvedSchemaState(kgId: string, currentVersionId: string): Promise<ResolvedSchemaStateResponse> {
    const parsedVersionId: number = Number(currentVersionId);

    if (Number.isNaN(parsedVersionId) || parsedVersionId <= 0) {
      return {
        positions: {},
        sourceVersionId: null,
      };
    }

    let versionToCheck: number = parsedVersionId;

    while (versionToCheck > 0) {
      const resolvedState = await this.getSchemaStateByVersion(kgId, String(versionToCheck), currentVersionId);

      if (resolvedState) {
        return resolvedState;
      }

      versionToCheck -= 1;
    }

    return {
      positions: {},
      sourceVersionId: null,
    };
  }

  private async getSchemaStateByVersion(kgId: string, versionId: string, currentVersionId: string): Promise<ResolvedSchemaStateResponse | null> {
    try {
      const stateResponse: GetSchemaStateDownloadResponse = await apiService.getErdStatDownloadUrl(kgId, versionId);

      const downloadUrl: string = stateResponse.data.attributes.download_url;
      if (!downloadUrl) { return null; }

      const positions: Record<string, Position> = await apiService.getErdSchemaState(downloadUrl);

      if (!Object.keys(positions).length) {
        return null;
      }

      return {
        positions,
        sourceVersionId: versionId === currentVersionId ? null : versionId,
      };
    } catch (error: unknown) {
      console.error(`Failed to fetch ERD schema state for version ${versionId}`, error);

      return null;
    }
  }
}